// @ts-check

import { getCasePropSelector } from '../utils/case-prop-selector'
import { createSelector } from '../utils/selector-utils'

/**
 * @param {{ name: string; memberId: string; time?: number }} param0
 * @returns {any} Changes to mark as ready for review
 */
export const actionSetRfr = ({ name, memberId, time }) => ({
  'rfr.name': name,
  'rfr.memId': memberId,
  'rfr.time': time || Date.now(),
})

/** @returns {any} Changes to clear ready for review */
export const actionClearRrf = () => ({
  rfr: null,
})

const selectRfrRaw = getCasePropSelector('rfr', null)

/**
 * @param {CaseData} caseData
 * @returns {{
 *   name: string
 *   memberId: string
 *   time: number
 * } | null}
 */
export const selectRfr = createSelector(selectRfrRaw, raw => {
  if (!raw) return null
  const { name, memId, time } = raw
  return name && memId && time ? { name, memberId: memId, time } : null
})

/**
 * @param {CaseData} caseData
 * @returns {boolean}
 */
export const selectIsRfr = createSelector(selectRfr, rfr => !!rfr)
